import moment from 'moment';
import 'moment/locale/es';

moment.updateLocale('es', {
  week: {
    dow: 1
  }
});

export const MONTHS_NAMES = moment.months();

export const WEEKDAYS_NAMES = moment.weekdays(true);

const daysFromNumbers = (thisYear, thisMonth) => dayNumber =>
  moment()
    .year(thisYear)
    .month(thisMonth)
    .date(dayNumber + 1)
    .locale('es')
    .format('Do');

export const getDaysInMonth = (today = new Date()) => {
  const now = moment(today);
  const thisYear = now.year();
  const thisMonth = now.month();
  const generateMonthDayNumbers = [...Array(moment(now).daysInMonth()).keys()];
  const thisMonthDaysNumbers = daysFromNumbers(thisYear, thisMonth);

  return generateMonthDayNumbers.map(thisMonthDaysNumbers);
};

export const getDaysInPeriod = (baseDate, cutoffDate) => {
  const startDate = moment(baseDate).subtract(1, 'day');
  const endDate = moment(cutoffDate).subtract(1, 'day');
  const thisYear = startDate.year();
  const thisMonth = startDate.month();

  const generateThisMonthDayNumbers = [
    ...Array(moment(startDate).daysInMonth()).keys()
  ];
  const daysOfThisMonth = generateThisMonthDayNumbers.filter(
    e => e >= moment(startDate).date()
  );
  const generateNextMonthDayNumbers = [
    ...Array(moment(endDate).daysInMonth()).keys()
  ];
  const daysOfNextMonth = generateNextMonthDayNumbers.filter(
    e => e <= moment(endDate).date()
  );
  const daysOfThisPeriod = daysOfThisMonth.concat(daysOfNextMonth);

  const thisMonthDaysNumbers = daysFromNumbers(thisYear, thisMonth);
  return daysOfThisPeriod.map(thisMonthDaysNumbers);
};

export const getHistoricMonths = (baseDate, cutoffDate) => {
  moment.locale('es');
  const startDate = moment(baseDate).startOf('month');
  const endDate = moment(cutoffDate).endOf('month');
  const monthNames = moment.monthsShort();
  const diffInMonths = endDate.diff(startDate, 'months', true);
  const totalMonths = Math.ceil(diffInMonths);

  const historicMonthLabels = [];
  let currentMonth = startDate.month();
  let currentYear = startDate.year();

  for (let i = 0; i < totalMonths; i++) {
    const monthName = monthNames[currentMonth];
    const shortYear = String(currentYear).slice(-2);
    const monthLabel = `${monthName} ${shortYear}`;
    historicMonthLabels.push(monthLabel);
    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
  }
  return historicMonthLabels;
};

export const getHistoricPeriods = (baseDate = '2021-01-01', cutoffDate = Date.now()) => {
  const startDate = moment(baseDate).startOf('month');
  const endDate = moment(cutoffDate).endOf('month');
  const diffInMonths = endDate.diff(startDate, 'months', true);
  const totalMonths = Math.ceil(diffInMonths);
  const historicMonthLabels = [];
  for (let i = 0; i < totalMonths; i++) {
    const iterativeDate = startDate.clone().add(i, 'months');
    historicMonthLabels.push(iterativeDate.format('YYYY[-]MM'));
  }
  return historicMonthLabels;
}

export const maybeThisMonth = (date, now = new Date()) =>
  moment(date).isSame(now, 'month');
export const maybePastMonth = (
  date,
  pastMonth = moment()
    .subtract(1, 'month')
    .toDate()
) => moment(date).isSame(pastMonth, 'month');
export const maybeThisPeriod = (date, baseDate, cutoffDate) =>
  moment(date).isBetween(baseDate, cutoffDate, undefined, '[]');
export const maybeThisYear = (date, now = new Date()) =>
  moment(date).isSame(now, 'year');
export const maybeThisWeek = (date, now = new Date()) =>
  moment(date).isSame(now, 'isoWeek');
export const maybePastYear = (
  date,
  thisYear = moment()
    .startOf('year')
    .toDate()
) => moment(date).isBefore(thisYear, 'year');
export const maybeHistoric = (date, baseDate, cutoffDate) =>
  moment(date).isBetween(baseDate, cutoffDate, undefined, '[]');

const GET_CURRENT_PERIODS = {
  month: maybeThisMonth,
  pastMonth: maybePastMonth,
  period: maybeThisPeriod,
  pastPeriod: maybeThisPeriod,
  year: maybeThisYear,
  pastYear: maybePastYear,
  week: maybeThisWeek,
  historic: maybeThisPeriod
};

export const countDatesInPeriodRange = period => (dates = []) => {
  const byPeriod = GET_CURRENT_PERIODS[period];

  return dates.filter(date => byPeriod(date)).length;
};

export const isInPeriod = (period, date, baseDate, cutoffDate) => {
  return GET_CURRENT_PERIODS[period](date, baseDate, cutoffDate);
};

export const diffInMinutes = (time, compareTime) => {
  const startTime = new Date(time);
  const endTime = new Date(compareTime);
  const diff = endTime.getTime() - startTime.getTime();
  return diff / 60000;
};
